import React from 'react';
import { forceCheck } from 'react-lazyload';
import { Link } from 'react-router-dom';
import LazyLoad from 'react-lazyload';
import BeerHover from 'images/beer-hover.jpg';
import MixersHover from 'images/mixers-hover.jpg';
import SpiritsHover from 'images/spirits-hover.jpg';
import WineHover from 'images/wine-hover.jpg';

export default function HeaderNav() {
  return (
    <div id="nav-left">
      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/beer">
          <span className="nav-link-label">Beer</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={BeerHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">Trending Beer</div> */}
            <Link to="/pilsner">
              <span className="nav-link-dropdown-label">Pilsner</span>
            </Link>
            <Link to="/light-lager">
              <span className="nav-link-dropdown-label">Light Lager</span>
            </Link>
            <Link to="/india-pale-ale">
              <span className="nav-link-dropdown-label">India Pale Ale</span>
            </Link>
            <Link to="/belgian-french-ale">
              <span className="nav-link-dropdown-label">
                Belgian &amp; French Ale
              </span>
            </Link>
            <Link to="/ciders">
              <span className="nav-link-dropdown-label">Ciders</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/american-ale">
              <span className="nav-link-dropdown-label">American Ale</span>
            </Link>
            <Link to="/stout">
              <span className="nav-link-dropdown-label">Stout</span>
            </Link>
            <Link to="/specialty-beer">
              <span className="nav-link-dropdown-label">Specialty Beer</span>
            </Link>
            <Link to="/light-hybrid-beer">
              <span className="nav-link-dropdown-label">Light Hybrid Beer</span>
            </Link>
            <Link to="/german-wheat-rye-beer">
              <span className="nav-link-dropdown-label">
                German Wheat &amp; Rye Beer
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/belgian-strong-ale">
              <span className="nav-link-dropdown-label">
                Belgian Strong Ale
              </span>
            </Link>
            <Link to="/sour-ale">
              <span className="nav-link-dropdown-label">Sour Ale</span>
            </Link>
            <Link to="/beer">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/wine">
          <span className="nav-link-label">Wine</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={WineHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            <Link to="/red-wine">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Red Wine
              </div>
            </Link>
            <Link to="/cabernet-sauvignon">
              <span className="nav-link-dropdown-label">
                Cabernet Sauvignon
              </span>
            </Link>
            <Link to="/pinot-noir">
              <span className="nav-link-dropdown-label">Pinot Noir</span>
            </Link>
            <Link to="/red-blend">
              <span className="nav-link-dropdown-label">Red Blend</span>
            </Link>
            <Link to="/malbec">
              <span className="nav-link-dropdown-label">Malbec</span>
            </Link>
            <Link to="/red-wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/white-wine">
              <span className="nav-link-dropdown-label dropdown-category-title">
                White Wine
              </span>
            </Link>
            <Link to="/sauvignon-blanc">
              <span className="nav-link-dropdown-label">Sauvignon Blanc</span>
            </Link>
            <Link to="/chardonnay">
              <span className="nav-link-dropdown-label">Chardonnay</span>
            </Link>
            <Link to="/pinot-grigio">
              <span className="nav-link-dropdown-label">Pinot Grigio</span>
            </Link>
            <Link to="/riesling">
              <span className="nav-link-dropdown-label">Riesling</span>
            </Link>
            <Link to="/white-wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/wine">
              <span className="nav-link-dropdown-label dropdown-category-title">
                More Wines
              </span>
            </Link>
            <Link to="/rose">
              <span className="nav-link-dropdown-label">Rosé</span>
            </Link>
            <Link to="/champagne-sparkling">
              <span className="nav-link-dropdown-label">
                Champagne &amp; Sparkling
              </span>
            </Link>
            <Link to="/sake">
              <span className="nav-link-dropdown-label">Sake</span>
            </Link>
            <Link to="/wine">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div
        className="category nav-link-dropdown"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/spirits">
          <span className="nav-link-label">Spirits</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={SpiritsHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">Trending Spirits</div> */}
            <Link to="/whiskey">
              <span className="nav-link-dropdown-label">
                Whiskey &amp; Scotch
              </span>
            </Link>
            <Link to="/vodka">
              <span className="nav-link-dropdown-label">Vodka</span>
            </Link>
            <Link to="/tequila">
              <span className="nav-link-dropdown-label">
                Tequila &amp; Mezcal
              </span>
            </Link>
            <Link to="/rum">
              <span className="nav-link-dropdown-label">Rum</span>
            </Link>
            <Link to="/gin">
              <span className="nav-link-dropdown-label">Gin</span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/cordials">
              <span className="nav-link-dropdown-label">
                Cordials, Liqueurs &amp; Bitters
              </span>
            </Link>
            <Link to="/cocktails-combos">
              <span className="nav-link-dropdown-label">
                Cocktails &amp; Combos
              </span>
            </Link>
            <Link to="/bourbon-whiskey">
              <span className="nav-link-dropdown-label">Bourbon Whiskey</span>
            </Link>
            <Link to="/irish-whiskey">
              <span className="nav-link-dropdown-label">Irish Whiskey</span>
            </Link>
            <Link to="/single-malt-scotch">
              <span className="nav-link-dropdown-label">
                Single Malt Scotch
              </span>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            {/* <div className="nav-link-dropdown-label dropdown-category-title">{'\u00A0'}</div> */}
            <Link to="/blanco--silver-tequila">
              <span className="nav-link-dropdown-label">
                Blanco / Silver Tequila
              </span>
            </Link>
            <Link to="/reposado-tequila">
              <span className="nav-link-dropdown-label">Reposado Tequila</span>
            </Link>
            <Link to="/anejo-tequila">
              <span className="nav-link-dropdown-label">Añejo Tequila</span>
            </Link>
            <Link to="/spirits">
              <span className="nav-link-dropdown-label view-more-label">
                All<span className="icon-arrow-right" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="category nav-link-dropdown category--gifting">
        <a href="/gifting">
          <span className="nav-link-label">Gifts</span>
        </a>
      </div>

      <div
        className="category nav-link-dropdown visible-lg-inline"
        onMouseOver={() => forceCheck()}
      >
        <Link to="/more">
          <span className="nav-link-label">More</span>
        </Link>
        <div className="dropdown">
          <div className="nav-link-dropdown-border" />
          <LazyLoad once={true} height={208}>
            <img src={MixersHover} />
          </LazyLoad>
          <div className="nav-link-dropdown-section">
            <Link to="/mixers">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Mixers
              </div>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/snacks">
              <div className="nav-link-dropdown-label dropdown-category-title">
                Snacks
              </div>
            </Link>
          </div>
          <div className="nav-link-dropdown-section">
            <Link to="/cigars-tobacco">
              <span className="nav-link-dropdown-label dropdown-category-title">
                Cigars &amp; Tobacco
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="category visible-lg-inline">
        <a href="/bartenders">
          <span className="nav-link-label">Book a Bartender</span>
        </a>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/components/header/nav.js